import { render } from "./IncidentDetail.vue?vue&type=template&id=725756d6"
import script from "./IncidentDetail.vue?vue&type=script&lang=js"
export * from "./IncidentDetail.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__